import { useEffect } from 'react';
import { qs } from '../modules/common'
import { isMobile } from 'react-device-detect';
import useCommonTemplate from '../hooks/useCommonTemplate';
const MouseStalker = () => {

  const commonTemplate = useCommonTemplate();

  let stalker: any;
  useEffect(() => {
    if (!isMobile && commonTemplate.enabled) {
      stalker = qs('#mouse_stalker');
      document.addEventListener('mousemove', stalk);
    } else {
      stalker = qs('#mouse_stalker');
      stalker.style.opacity = 0;
      stalker.style.pointerEvents = "none";
      stalker.style.transition = "none";
    }
    return () => {
      document.removeEventListener('mousemove', stalk);
    }
  }, []);

  function stalk(e: any) {
    stalker.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
  }

  return (
    <>
      {/* {(!isMobile) &&
        <div id="mouse_stalker" style={{ transform: "translate(0, 0)" }}></div>
      } */}
    </>
  );
}
export default MouseStalker;